import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    insurerCategoryAll: [],
    insurerCategory: {},
    currentPage: 1,
    totalPages: 1,
    rowsPerPage: 10,
    sortBy: "name",
    sortOrder: "asc",
};

const insurerCategorySlice = createSlice({
    name: "insurerCategory",
    initialState,
    reducers: {
        setInsurerCategoryAll: (state, action) => {
            state.insurerCategoryAll = action.payload;
        },
        setInsurerCategory: (state, action) => {
            state.insurerCategory = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload;
        },
    },
});

export const {
    setInsurerCategoryAll,
    setInsurerCategory,
    setCurrentPage,
    setTotalPages,
    setRowsPerPage,
} = insurerCategorySlice.actions;

export default insurerCategorySlice.reducer;
